<template>
  <section id="curators" ref="curators" class="tight half bb pb">

      <collapse
        :uid="curators.uid"
        parent="curators"
        :fold="true"
      >
        <template v-slot:header>
          <div class="first">{{ curators.title }}</div>
        </template>
        <template v-slot:content>
          <div
            v-for="item in curators.peoples"
            :key="item.title"
            class="grid mobile mb"
          >
            <div>
              <img v-if="item.image" :src="item.image.url" :alt="item.name" />
            </div>
            <div>
                <div class="first">{{ item.name }}</div>
                <div class="pr2" v-html="item.bio"></div>
            </div>
          </div>
        </template>
      </collapse>
     
  </section>
</template>

<script>
import API from "@/api/service";
import Collapse from "@/components/Collapse.vue";
export default {
  components: {
    Collapse
  },
  data() {
    return {
      curators: []
    };
  },
  created() {
    API.curators(this.$i18n.locale).then(page => {
      this.curators = page.data.result;
    });
  }
};
</script>

<style lang="scss" scoped></style>
